import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getErrorResponseData } from '@app/routing/Session/ErrorResponse'

import { useSnackbar } from '@context/SnackbarContext'

import { ResponseError, useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { CreateTradingAccountIntroducingBrokerRebateGroupBulk } from '@model/CreateTradingAccountIntroducingBrokerRebateGroupBulk'

interface AddIBTradingAccountsRebateGroups {
  isLoading: boolean
  addToGroups: (payload: CreateTradingAccountIntroducingBrokerRebateGroupBulk) => Promise<void>
}

interface AddIBTradingAccountsRebateGroupsParams {
  onCompleted?: () => void
}

export const useAddIBTradingAccountsRebateGroups = ({
  onCompleted,
}: AddIBTradingAccountsRebateGroupsParams = {}): AddIBTradingAccountsRebateGroups => {
  const apiClient = useApiClient(ClientApiClient)
  const { addSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  const addToGroups = async (payload: CreateTradingAccountIntroducingBrokerRebateGroupBulk) => {
    setIsLoading(true)

    try {
      await apiClient.addIBTradingAccountsRebateGroups(payload)

      addSnackbar.success({
        message: t(
          'IB.RebatesPage.ClientsPage.You have successfully added the trading accounts to the group'
        ),
      })

      setIsLoading(false)
      onCompleted?.()
    } catch (error: unknown) {
      const { response } = getErrorResponseData(error as ResponseError)
      const errorResponseCode = response?.response?.data?.code

      if (
        errorResponseCode === 'trading_account_has_another_introducing_broker_rebate' ||
        errorResponseCode === 'trading_account_has_another_introducing_broker_individual_rebate' ||
        errorResponseCode === 'trading_account_has_another_introducing_broker_group_rebate'
      ) {
        addSnackbar.error({
          message: t('errors.Please, reset TA(s) settings first'),
        })
      }

      setIsLoading(false)
    }
  }

  return { addToGroups, isLoading }
}
